import React, {Component} from 'react';

import {all_sounds} from './SoundManager';
import App, {initial_app_images} from './App';
import KeyboardSelectionListener from './KeyboardSelectionListener';
import {base_robot_images} from './Robot';
import Timer from './Timer';

import load_bar_1 from './assets/loading_page/LOADER_01.png';
import load_bar_2 from './assets/loading_page/LOADER_02.png';
import load_bar_3 from './assets/loading_page/LOADER_03.png';
import load_bar_4 from './assets/loading_page/LOADER_04.png';
import load_bar_5 from './assets/loading_page/LOADER_05.png';
import load_bar_6 from './assets/loading_page/LOADER_06.png';
import load_bar_7 from './assets/loading_page/LOADER_07.png';
import load_bar_8 from './assets/loading_page/LOADER_08.png';
import load_bar_9 from './assets/loading_page/LOADER_09.png';
import load_bar_10 from './assets/loading_page/LOADER_10.png';
import load_bar_11 from './assets/loading_page/LOADER_11.png';
import load_bar_12 from './assets/loading_page/LOADER_12.png';

import background from './assets/loading_page/LOADERpage_BG.png';

import left_door_img from './assets/loading_page/LOADERpage_Doorleft.png';
import right_door_img from './assets/loading_page/LOADERpage_Doorright.png';

import './App.css';

// createjs is a globally included script
const createjs = window.createjs;

const load_lights = [
    null,
    load_bar_1,
    load_bar_2,
    load_bar_3,
    load_bar_4,
    load_bar_5,
    load_bar_6,
    load_bar_7,
    load_bar_8,
    load_bar_9,
    load_bar_10,
    load_bar_11,
    load_bar_12,
];

const DOOR_STATES = {
    OPEN: 'open',
    CLOSING: 'closing',
    OPENING: 'opening',
    DONE: 'done',
}

export default class AppLoader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded_loader_images: false,
            loaded_app_data: false,

            load_index: 0,
            door_state: DOOR_STATES.OPEN,
        };



        // loadAllSounds(() => {
        //     // TODO - actually wait for sounds to load before starting?
        //     // preload images?            
        // });
    }

    componentDidMount() {
        // this app loads in a iframe
        // we need to focus the iframe
        window.focus();
    }

    on_background_load() {
        // Use preload js to preload all other "loader" images
        const queue = new createjs.LoadQueue();
        queue.on('complete', () => this.on_loader_images_loaded());
        queue.loadManifest([
            load_bar_1,
            load_bar_2,
            load_bar_3,
            load_bar_4,
            load_bar_5,
            load_bar_6,
            load_bar_7,
            load_bar_8,
            load_bar_9,
            load_bar_10,
            load_bar_11,
            load_bar_12,
            left_door_img,
            right_door_img,
        ]);
    }
    on_loader_images_loaded() {
        // Now we want to initiate "load light" sequence, while preloading key app images
        this.setState({loaded_loader_images: true});

        const queue = new createjs.LoadQueue();
        queue.on('complete', () => this.on_app_images_loaded());
        queue.installPlugin(createjs.Sound);

        queue.loadManifest(base_robot_images);
        queue.loadManifest(initial_app_images);
        queue.loadManifest(all_sounds);
    }
    on_app_images_loaded() {
        this.setState({loaded_app_data: true});
    }

    render() {
        const {loaded_loader_images, loaded_app_data, load_index, door_state} = this.state;

        // First thing we do is display the background image
        // Once it's fully loaded, we preload other loader images, then initiate load sequence
        if (!loaded_loader_images) {
            return <div className="App" autoFocus>
                <div className="App-layer">
                    <img 
                        src={background} 
                        onLoad={e => this.on_background_load()}
                        style={{position: 'absolute', top: 0, left: 0,}} />
                </div>
            </div>
        }

        // begin rendering the app underneath the other layers before doors open
        let app = null;
        if (load_index > 11 && loaded_app_data) {
            const start_robot_hand = door_state === DOOR_STATES.DONE;
            app = <App start_robot_hand={start_robot_hand} />;
        }

        // loading background/indicator - only if the "doors" aren't already closed
        let loader = null;
        if (door_state == DOOR_STATES.OPEN || door_state == DOOR_STATES.CLOSING) {
            let load_light_image = null;
            if (load_index) {
                load_light_image = <img src={load_lights[load_index]} style={{position: 'absolute', bottom: 0, left: 0,}} />;
            }
            loader = <div className="App-layer">
                <img src={background} style={{position: 'absolute', top: 0, left: 0,}} />
                {load_light_image}
            </div>
        }

        let left_door = null;
        let right_door = null;
        switch (door_state) {
        case DOOR_STATES.OPEN:
            left_door = <img src={left_door_img} className="AppLoader-door AppLoader-door-left" />;
            right_door = <img src={right_door_img} className="AppLoader-door AppLoader-door-right" />;
            break;
        case DOOR_STATES.CLOSING:
            left_door = <img src={left_door_img} className="AppLoader-door"/>;
            right_door = <img 
                src={right_door_img} 
                className="AppLoader-door" 
                style={{left: '0'}}
                onTransitionEnd={() => this.setState({door_state: DOOR_STATES.OPENING})}
            />;
            break;
        case DOOR_STATES.OPENING:
            // Don't actually open doors until we've pre loaded app images
            if (!loaded_app_data) {
                left_door = <img src={left_door_img} className="AppLoader-door"/>;
                right_door = <img src={right_door_img} className="AppLoader-door" />;
                break;
            }

            left_door = <img src={left_door_img} className="AppLoader-door AppLoader-door-left"/>;
            right_door = <img 
                src={right_door_img} 
                className="AppLoader-door AppLoader-door-right" 
                style={{left: '50'}}
                onTransitionEnd={() => this.setState({door_state: DOOR_STATES.DONE})}
            />;
            break;
        }

        let timer = null;
        if (door_state === DOOR_STATES.OPEN) {
            if (load_index == load_lights.length-1) {
                timer = <Timer
                    delay={150}
                    on_timeout={() => {this.setState({
                        door_state: DOOR_STATES.CLOSING,
                    })}}
                    reset_prevention_key={'doors_closing'}
                />                
            }
            else {
                timer = <Timer
                    delay={150}
                    on_timeout={() => {this.setState({
                        load_index: load_index + 1,
                    })}}
                    reset_prevention_key={load_index}
                />
            }
        }

        return <div className="App" autoFocus>
            <iframe src={process.env.PUBLIC_URL + '/cmf_tracking.html'} width="0" height="0" frameBorder="0"></iframe>
            {app}
            {loader}
            {left_door}
            {right_door}
            {timer}
        </div>
    }
}





// WEBPACK FOOTER //
// ./src/AppLoader.js